import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { getAllRows } from "../ReportElementHelper";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class UCCFiling extends Component {
  state = {
    filiningTables: [],
    savedResultID: "",
    internalID: "",
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadData = (props) => {
    const filiningTables = [];
    let recCount = 0;
    if (props.reportData !== undefined) {
      const uccFiling = this.props.isSilverReport
        ? _.get(props.node, "UCCFilings[0].UCCFiling")
        : _.get(
            props.reportData,
            "personReport.compReportResponse[0].individual[0].UCCFilings[0].UCCFiling"
          );
      if (uccFiling) {
        _.forEach(uccFiling, (record, index) => {
          const recs = [];
          getAllRows(record, recs, props, _.get(record, "$.display"));
          if (recs.length > 0) {
            filiningTables.push(
              <Table.Row key={`ucc_filing_${index}`}>
                <Table.Cell>
                  <Table>
                    <Table.Body>
                      <Table.Row>
                        <Table.HeaderCell
                          colSpan={2}
                          className="report-sub-section-header"
                        >
                          Filing
                        </Table.HeaderCell>
                      </Table.Row>
                      {recs}
                    </Table.Body>
                  </Table>
                </Table.Cell>
              </Table.Row>
            );
          }
        });
        recCount = filiningTables.length;
      } else {
        filiningTables.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={2}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    } else {
      filiningTables.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ filiningTables });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"UCC Filings"}
        rows={this.state.filiningTables}
      />
    );
  }
}

export default UCCFiling;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/UCCFiling.js